/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.TransactionEditor {
    angular.module("meevo.plugins.transactionEditor", []);
}